import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/download_staging/6a156bc01e93da001446ac34_1779981465150/gerantlink/src/app/order-fulfillment-kanban-board/components/KanbanBoardContent.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/download_staging/6a156bc01e93da001446ac34_1779981465150/gerantlink/src/components/AppLayout.tsx");
